import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {
    BehaviorSubject,
    EMPTY,
    throwError,
    timer,
    Observable,
} from 'rxjs';

import {Router} from '@angular/router';
import {catchError, distinctUntilChanged, filter, mergeMap, switchMap, take} from 'rxjs/operators';


import {LocalStorageService} from '../services/local-storage.service';
import {KeycloakTokenService} from '../services/keycloak-token.service';
import {PathEnum} from '../../app.routing';
import {SnackbarTypes} from '../../../@fuse/services/confirmation/snackbar/snackbar.component';
import {FuseConfirmationService} from '../../../@fuse/services/confirmation';
import {MatDialog} from "@angular/material/dialog";
import {environment} from '../../../environments/environment';




@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  isTokenRefreshing: BehaviorSubject<boolean | undefined> | undefined;
  private isLoggingOut = false;
  private errorRefresh: string = 'Errore durante l\'aggiornamento della sessione. Si prega di rieseguire la login.';

  /**
   * Constructor
   */
  constructor(
    private localStorageService: LocalStorageService,
    private fuseConfirmationService: FuseConfirmationService,
    private router: Router,
    private dialog: MatDialog,
    private keycloakTokenService: KeycloakTokenService
  ) {
  }

  /**
   * Intercept
   *
   * @param httpRequest
   * @param next
   */
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (httpRequest.url.includes('login') || httpRequest.url.includes(environment.keycloak.tokenEndpoint)) {
      console.log('Intercettata chiamata di login o refresh token, non utilizzo interceptor');
      return next.handle(httpRequest);
    }

    if (httpRequest.url.includes(environment.ticketsBackend.url) || httpRequest.url.includes('gestione-pratiche')) {
      return next.handle(httpRequest);
    }

    const authReq = httpRequest.clone();

    if (httpRequest.method !== 'OPTIONS') {
      return this.handleRequest(authReq, next);
    } else {
      return next.handle(authReq);
    }
  }

  handleRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any> | any> {
    return next.handle(request).pipe(
      catchError(
        (error: HttpErrorResponse) => {
          if (error.status === 401) {
            if (this.isLoggingOut) {
              return EMPTY;
            }
            if (!!this.isTokenRefreshing) {
              console.log('isTokenRefreshing esiste');
              return this.isTokenRefreshing.pipe(
                filter(value => value !== undefined),
                take(1),
                switchMap(
                  (result: any) => {
                    if (result) {
                      console.log('Chiamata handlerequest 1');
                      return timer(500).pipe(
                        switchMap(() => this.handleRequest(request.clone({
                          setHeaders: {
                            Authorization: 'Bearer ' + this.localStorageService.getAccessToken(),
                          },
                        }), next)));
                    } else {
                      return EMPTY;
                    }
                  }
                )
              );
            }
            else {
              console.log('isTokenRefreshing non esiste');
              this.isTokenRefreshing = new BehaviorSubject<boolean | undefined>(undefined);
              return this.keycloakTokenService.refreshToken(
                  this.localStorageService.getRefreshToken() || '').pipe(
                distinctUntilChanged(),
                take(1),
                mergeMap((result) => {
                  this.localStorageService.setToken(result.access_token, result.refresh_token, result.expires_in);
                  this.isTokenRefreshing?.next(true);
                  this.isTokenRefreshing = undefined;
                  console.log('Chiamata handlerequest 2');
                  return this.handleRequest(request.clone({
                    setHeaders: {
                      Authorization: 'Bearer ' + result.access_token,
                    },
                  }), next);
                }),
                catchError(() => {
                    this.isLoggingOut = true;
                    this.isTokenRefreshing?.next(false);
                    this.isTokenRefreshing = undefined;
                    this.fuseConfirmationService.openSnackBar({
                        message: this.errorRefresh,
                        type: SnackbarTypes.Error
                    });
                    this.localStorageService.cleanToken();
                    this.dialog?.closeAll();
                    this.router.navigateByUrl('/' + PathEnum.SIGN_IN, { replaceUrl: true }).then(() => {
                        this.isLoggingOut = false;
                    });
                    return EMPTY;
                }));
            }
          }
          else if (error?.status === 403 && error?.error?.code === 1009) {
              this.fuseConfirmationService.openSnackBar({
                  message:  error?.error?.message,
                  type: SnackbarTypes.Error
              });
              this.localStorageService.cleanToken();
              this.router.navigateByUrl('/' + PathEnum.SIGN_IN);
              return EMPTY;
          }
          else {
              return throwError(() => error);
          }
        }));
  }
}
